import {
  FormattedMessage,
  useIntl,
} from 'react-intl';

import { ResourceLink } from '@/core/components/ResourceLink';
import { searchMessages } from '@/core/messages/search.messages';
import { globalMessages } from '@/core/messages/global.messages';
import { ButtonVariant } from '@/core/components/Button';

import { ViewMoreButton } from '@/features/Sections/Moments/Moments.styles';

import { Pagination as PaginationType } from '@/utils/request.types';

import {
  ButtonWrapper,
  ListWrapper,
  Title,
  Wrapper,
} from './SearchResults.styles';
import { SearchData } from '../Search.types';
import { formatSearchResultItem } from '../helpers';

type SerchResultsProps = {
  data: SearchData;
  isLoading: boolean;
  pagination?: PaginationType;
  onShowMore: () => void;
}

export const SearchResults = ({
  isLoading,
  data,
  pagination,
  onShowMore,
}: SerchResultsProps) => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper>
      <Title>
        <FormattedMessage
          {...searchMessages.results}
          values={{ total: pagination?.total }}
        />
      </Title>
      <ListWrapper>
        {data.map(resultItem => {
          const formattedItem = formatSearchResultItem(resultItem);

          return (
            <ResourceLink
              key={`${resultItem.searchType}_${resultItem.id}`}
              data={formattedItem}
              type={resultItem.searchType}
              isSearchResult
            />
          );
        })}
      </ListWrapper>
      {!!pagination && data.length < pagination.total && !isLoading && (
        <ButtonWrapper>
          <ViewMoreButton
            label={formatMessage(globalMessages.viewMore)}
            variant={ButtonVariant.GHOST}
            onClick={onShowMore}
          />
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};
